import { CheckboxFilter } from '@lifebit-ai/lds'
import { ResultsState } from 'enums'
import React from 'react'

import {
  ApprovedIcon,
  FailedIcon,
  IconContainer,
  PendingIcon,
  PreparingIcon,
  ProcessingIcon,
  RejectedIcon
} from 'modules/requests/filters/StatusFilter.styles'
import type { Option } from 'modules/types'

interface StatusFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const StatusFilter: React.FC<StatusFilterProps> = ({ onApply, onReset }) => {
  const options = [
    {
      label: 'Preparing...',
      value: ResultsState.Preparing,
      element: (
        <IconContainer>
          <PreparingIcon text={false} />
          <span>Preparing...</span>
        </IconContainer>
      )
    },
    {
      label: 'Processing...',
      value: ResultsState.Processing,
      element: (
        <IconContainer>
          <ProcessingIcon text={false} />
          <span>Processing...</span>
        </IconContainer>
      )
    },
    {
      label: 'Approved',
      value: ResultsState.Complete,
      element: (
        <IconContainer className="approved-icon">
          <ApprovedIcon />
          <span>Approved</span>
        </IconContainer>
      )
    },
    {
      label: 'Rejected',
      value: ResultsState.Rejected,
      element: (
        <IconContainer>
          <RejectedIcon />
          <span>Rejected</span>
        </IconContainer>
      )
    },
    {
      label: 'Failed',
      value: ResultsState.Failed,
      element: (
        <IconContainer>
          <FailedIcon />
          <span>Failed</span>
        </IconContainer>
      )
    },
    {
      label: 'Pending',
      value: ResultsState.PendingVerification,
      element: (
        <IconContainer>
          <PendingIcon />
          <span>Pending</span>
        </IconContainer>
      )
    }
  ]

  return <CheckboxFilter label="Status" options={options} onApply={onApply} onReset={onReset} withFuzzySearch={false} />
}
